module.exports = __webpack_public_path__ + "assets/46287d5c4498d95494c9e64f12da2ada.mp3";